/* ─── Catalogue articles avec statut stock ─────────────── */
export const catalog = [
  {
    id: 'p1', emoji: '👜', name: 'Pochette satin ivoire',
    brand: 'Net-a-Porter', site: 'net-a-porter.com',
    price: 340, size: 'Unique', category: 'Sacs',
    inStock: false, stockDate: null,
    lookId: '1', lookName: 'Élégance absolue', color: 'Ivoire',
  },
  {
    id: 'p2', emoji: '👟', name: 'Sneakers cuir blanc',
    brand: 'ASOS', site: 'asos.com',
    price: 89, size: 'T.38', category: 'Chaussures',
    inStock: false, stockDate: null,
    lookId: '2', lookName: 'Tailleur nuit', color: 'Blanc',
  },
  {
    id: 'p3', emoji: '🥻', name: 'Robe fluide ivoire',
    brand: 'Zalando', site: 'zalando.fr',
    price: 145, size: 'T.36', category: 'Robes',
    inStock: true, stockDate: '2026-04-11',
    lookId: '3', lookName: 'Robe fluide', color: 'Ivoire',
  },
  {
    id: 'p4', emoji: '👜', name: 'Sac structuré camel',
    brand: 'Zalando', site: 'zalando.fr',
    price: 55, size: 'Unique', category: 'Sacs',
    inStock: false, stockDate: null,
    lookId: '5', lookName: 'Bureau raffiné', color: 'Camel',
  },
  {
    id: 'p5', emoji: '💎', name: 'Bijou doré discret',
    brand: 'ASOS', site: 'asos.com',
    price: 48, size: 'Unique', category: 'Bijoux',
    inStock: true, stockDate: '2026-04-10',
    lookId: '1', lookName: 'Élégance absolue', color: 'Or',
  },
];

/* ─── Watchlist ──────────────────────────────────────────── */
export const initialWatchlist = [
  { productId: 'p1', addedAt: '2026-03-20', notifyOnRestock: true, notified: false },
  { productId: 'p2', addedAt: '2026-03-25', notifyOnRestock: true, notified: false },
  { productId: 'p3', addedAt: '2026-03-28', notifyOnRestock: true, notified: true  },
  { productId: 'p4', addedAt: '2026-04-01', notifyOnRestock: true, notified: false },
  { productId: 'p5', addedAt: '2026-04-05', notifyOnRestock: true, notified: true  },
];

/* ─── Notifications mock ─────────────────────────────────── */
export const initialNotifications = [
  {
    id: 'n1', type: 'restock', read: false,
    date: '2026-04-11T09:15:00', productId: 'p3',
    title: 'De retour en stock !',
    body: 'La Robe fluide ivoire (Zalando · T.36) est à nouveau disponible.',
    emoji: '🥻', price: 145, brand: 'Zalando', lookName: 'Robe fluide',
  },
  {
    id: 'n2', type: 'restock', read: false,
    date: '2026-04-10T14:30:00', productId: 'p5',
    title: 'De retour en stock !',
    body: 'Le Bijou doré discret (ASOS · Unique) est à nouveau disponible.',
    emoji: '💎', price: 48, brand: 'ASOS', lookName: 'Élégance absolue',
  },
  {
    id: 'n3', type: 'price_drop', read: true,
    date: '2026-04-08T11:00:00', productId: 'p2',
    title: 'Baisse de prix',
    body: 'Les Sneakers cuir blanc (ASOS) sont passées de 110 € à 89 €.',
    emoji: '👟', price: 89, oldPrice: 110, brand: 'ASOS', lookName: 'Tailleur nuit',
  },
  {
    id: 'n4', type: 'low_stock', read: true,
    date: '2026-04-06T16:45:00', productId: 'p1',
    title: 'Dernières pièces',
    body: 'La Pochette satin ivoire (Net-a-Porter) · plus que 2 exemplaires.',
    emoji: '👜', price: 340, brand: 'Net-a-Porter', lookName: 'Élégance absolue',
  },
];
